export class OpenBankingAccount {
  accountId!: string;
  displayName!: string;
  accountReference!: {
    iban: string;
    currency: string;
  };
}
